import { loadable } from "../loadable";
import IconAssetDefault from "./IconAssetDefault";

export default loadable(() => import(/* webpackChunkName: "IconAsset" */ './IconAssetWrapped'), IconAssetDefault);
